import { Box, Center, HStack, IconButton } from '@chakra-ui/react';
import { Bag, User } from '@time-line/components/icons';
import { SiteSearchDesktop } from 'components/siteSearch/SiteSearchDesktop';
import { useCartCount } from 'hooks/cart/useCartCount';
import { useCartUI } from 'hooks/cart/useCartUI';
import { env } from 'lib/constants/env';

import { RESPONSIVE_BP } from './constants';
import { useNav } from './useNav';

export interface IconNavProps {
  variant?: 'default' | 'simple';
}

export function IconNav({ variant }: IconNavProps) {
  const isDefaultVariant = variant === 'default';
  const isSimpleVariant = variant === 'simple';

  const { accountNav } = useNav();

  const { toggleCart } = useCartUI();
  const cartCount = useCartCount();

  return (
    <HStack gap="xs">
      {accountNav && isDefaultVariant && (
        <IconButton
          display={{ base: 'none', [RESPONSIVE_BP]: 'block' }}
          variant="link"
          aria-label={accountNav.label}
          color="currentColor"
          icon={<User width="sm!important" />}
          onClick={accountNav.onClick}
        />
      )}
      {env.NEXT_PUBLIC_SITE_SEARCH_ENABLED && isDefaultVariant && (
        <SiteSearchDesktop />
      )}
      {((isSimpleVariant && cartCount > 0) || isDefaultVariant) && (
        <IconButton
          onClick={() => toggleCart(true)}
          variant="link"
          aria-label={cartCount ? `Cart, ${cartCount} items` : 'Cart'}
          color="currentColor"
          icon={
            <Box>
              <Center
                as="span"
                aria-hidden
                pos="absolute"
                zIndex={1}
                top="-2px"
                left="55%"
                bgColor="red.300"
                borderRadius="40px"
                minW="15px"
                h="15px"
                px="4px"
                fontFamily="mono"
                fontSize="9px"
                lineHeight={1}
                color="gray.50"
                letterSpacing={0}
                hidden={!cartCount}
              >
                {cartCount}
              </Center>
              <Bag
                width="sm!important"
                sx={{
                  path: {
                    vectorEffect: 'non-scaling-stroke',
                  },
                }}
              />
            </Box>
          }
        />
      )}
    </HStack>
  );
}
